import React, { memo } from 'react';

import PrimaryButton from '@common/button';
import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';
import { Timetable_timetable_groups_rows_columns as Column } from '@typings/api';
import { handleKeystroke } from '@utils/handleKeystroke';

interface Props {
  column: Column;
  date: string | null;
  isExpanded?: boolean;
  isDisabled?: boolean;
  onClick: (order: number) => void;
  onSelect: (order: number) => void;
  order: number;
  timeSlot: string;
}

function Slot({
  column,
  date,
  isDisabled,
  isExpanded,
  onClick,
  onSelect,
  order,
  timeSlot,
}: Props) {
  const { t } = useScopedTranslation();

  function handleClick() {
    return onClick(order);
  }

  function handleSelect(event: React.SyntheticEvent<HTMLButtonElement>) {
    event.stopPropagation();

    return onSelect(order);
  }

  return (
    <div
      aria-label={`${date} - ${timeSlot}`}
      className={`border border-gray-300 border-t-0 py-2 px-1 leading-4 flex-1 truncate text-center cursor-pointer select-none ${
        column.open ? '' : 'bg-gray-100 cursor-not-allowed'
      }`}
      onClick={handleClick}
      onKeyDown={(e) => handleKeystroke(e.code)}
      role="button"
      tabIndex={column.open ? 0 : -1}
    >
      {column.open ? (
        <div className={`overflow-hidden transition-height duration-75 `}>
          <p className="text-sm xl:text-base">{timeSlot}</p>
          {isExpanded && (
            <PrimaryButton
              className="z-10 w-full h-10 mt-2 leading-4"
              disabled={isDisabled}
              onClick={handleSelect}
              type="submit"
            >
              {t('button.continue')}
            </PrimaryButton>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default memo(Slot);
